<template>
  <div :class="this.inputClass()">
    <label v-if="labelText" class="field-label" :htmlFor="name">
      {{ labelText }}
    </label>
    <select
      :disabled="disabled"
      tabindex="0"
      :id="name"
      class="field-input"
      :placeholder="placeholder"
      :type="type"
      v-model="localValue"
      :autoComplete="autoComplete"
      :maxLength="maxLength"
      @blur="onBlur"
      @input="onChange"
    >
      <option v-if="placeholder" value="" disabled selected>
        {{ placeholder }}
      </option>
      <option
        v-for="({ label, value }, index) in options"
        :key="`:id-${value}-${index}`"
        :value="value"
      >
        {{ label }}
      </option>
    </select>
    <label v-if="showValidation" class="field-status"
      ><CustomIcon name="warning" />{{ fieldValidator.message }}</label
    >
  </div>
</template>
<script>
import {
  ValidationData,
  createValidationDataObject,
} from "@/utils/form-validation.js";
import CustomIcon from "./CustomIcon";

export default {
  name: "selector-component",
  data() {
    return {
      localValue: this.value,
    };
  },
  components: {
    CustomIcon,
  },
  watch: {
    value(v) {
      this.localValue = v;
    },
  },
  props: {
    onChange: {
      type: Function,
      default(event) {
        return event;
      },
    },
    onBlur: {
      type: Function,
      default(event) {
        return event;
      },
    },
    validator: {
      type: Function,
      default() {
        return ValidationData;
      },
    },
    options: [],
    placeholder: String,
    disabled: Boolean,
    type: String,
    name: String,
    value: String,
    labelText: String,
    touched: Boolean,
    maxLength: Number,
    autoComplete: Boolean,
  },
  methods: {
    inputClass() {
      const { valid } = this.fieldValidator;

      let className = "field selector";

      if (this.touched && !valid) {
        className += " is-invalid";
      }

      return className;
    },
  },
  computed: {
    fieldValidator() {
      const { valid, message } = this.validator
        ? this.validator(this.value)
        : createValidationDataObject();

      return { valid, message };
    },
    showValidation() {
      const { valid } = this.fieldValidator;

      return !valid && this.touched;
    },
  },
};
</script>
